export class Statistics {
    draft: 0;
    review: 0;
    published: 0;
    rejected: 0;
}

export class StatisticsResponse {
    message: '';
    statistics: Statistics;
}
